import { EntityType } from 'types/entityType';
import {
  FRAMES_ACTIVATE_API_URL,
  FRAMES_ARCHIVE_API_URL,
  FRAMES_DEACTIVATE_API_URL,
  FRAMES_UNARCHIVE_API_URL,
  LINKED_ASSETS_ACTIVATE_API_URL,
  LINKED_ASSETS_ARCHIVE_API_URL,
  LINKED_ASSETS_DEACTIVATE_API_URL,
  LINKED_ASSETS_UNARCHIVE_API_URL,
} from 'utils/defaults';

export type ActionType = 'activate' | 'deactivate' | 'archive' | 'unarchive';

export const entityActionUrls = {
  [EntityType.FRAME]: {
    activate: FRAMES_ACTIVATE_API_URL,
    deactivate: FRAMES_DEACTIVATE_API_URL,
    archive: FRAMES_ARCHIVE_API_URL,
    unarchive: FRAMES_UNARCHIVE_API_URL,
  },
  [EntityType.LINKED_ASSET]: {
    activate: LINKED_ASSETS_ACTIVATE_API_URL,
    deactivate: LINKED_ASSETS_DEACTIVATE_API_URL,
    archive: LINKED_ASSETS_ARCHIVE_API_URL,
    unarchive: LINKED_ASSETS_UNARCHIVE_API_URL,
  },
};
